export default __webpack_public_path__ + "static/media/upload-disabled.21a9dc0a.svg";